import {call, put, takeEvery} from 'redux-saga/effects';

import get from 'lodash/get';
import Api from '../lib/Api';

import {fetchLoginFailed, fetchLoginSucceeded} from "../store/auth/actions";
import {FETCH_LOGIN_REQUESTED} from "../store/auth/actionTypes";

const _getAuthRequested = (data) => Api.postAuth(data)
    .then((response) => response)
    .catch((e) => e.response);

function* fetchAuth(action) {
    try {
        const response = yield call(_getAuthRequested, action.payload);
        const {access_token, user} = response.data.data;
        yield put(fetchLoginSucceeded({user, access_token}));
        if (access_token){ yield action.payload.loginSucceeded()}
    } catch (error) {
        yield put(fetchLoginFailed({error}));
    }
}

function* AuthSaga() {
    yield takeEvery(FETCH_LOGIN_REQUESTED, fetchAuth);
}

export default AuthSaga;



// WEBPACK FOOTER //
// ./src/saga/auth.js